// extracted by mini-css-extract-plugin
module.exports = {"heading1":"_7f0ceb61","heading2":"_292e6ea7","heading3":"_a13cbdfb","body1":"_4129d51f","body2":"_c9c82885","body3":"_dbaa8a23"};